export default __webpack_public_path__ + "static/international-yards-desktop-640116f87ba253c012041ab7b5710e06.svg";